import { createReducer } from 'deox';
import produce from 'immer';
import { logout, setToken, setUser } from './actions';
import { userState } from './types';

export const userInitialState: userState = {
  user: localStorage.user ? JSON.parse(localStorage.getItem('user') as string) : null,
  token: localStorage.token || '',
};

export const userReducer = createReducer(userInitialState, (handle) => [
  handle(setUser, (state, { payload }: any) =>
    produce(state, (draft) => {
      if (!payload) {
        draft.token = '';
      }
      draft.user = payload;
    })
  ),
  handle(setToken, (state, { payload }: any) =>
    produce(state, (draft) => {
      draft.token = payload;
    })
  ),
  handle(logout, (state) =>
    produce(state, (draft) => {
      draft.user = null;
      draft.token = '';
      // Clear from localStorage
      localStorage.removeItem('user');
      localStorage.removeItem('token');
    })
  ),
]);
